// New Features for 2025 and Coming Features for 2026

// Import images using Vite's import system for proper base path handling
import getInvolved1 from '/public/images/features/get-involved-1.png';
import getInvolved2 from '/public/images/features/get-involved-2.png';
import involvementFair1 from '/public/images/features/involvement-fair-1.png';
import involvementFair2 from '/public/images/features/involvement-fair-2.png';
import libraryReservations1 from '/public/images/features/library-reservations-1.png';
import libraryReservations2 from '/public/images/features/library-reservations-2.png';
import athletics1 from '/public/images/features/athletics-1.png';
import athletics2 from '/public/images/features/athletics-2.png';
import weather1 from '/public/images/features/weather-1.png';
import weather2 from '/public/images/features/weather-2.png';

export const newFeatures2025 = [
  {
    id: 'get-involved',
    title: 'Get Involved Tab',
    description: 'Everything you need to dive into Buckeye life - all in one place. Explore student organizations, catch up on athletics, discover campus events, see recreation facility capacity counts, and personalize your experience with custom app icons and wallpapers. In less than 6 months, the new tab has already cracked the top 20 screens for the year.',
    icon: '🎯',
    category: 'Engagement',
    images: [getInvolved1, getInvolved2]
  },
  {
    id: 'involvement-fair',
    title: 'Interactive Involvement Fair Experience',
    description: 'Navigate the fair like never before. Find your perfect student organization with interactive wayfinding, explore detailed profiles, and connect instantly - sign up or reach out to organizations right from the app. In its first year of use, 4,200 users explored this new feature (65,000 screen views), making more than 180 connections to student organizations.',
    icon: '🎪',
    category: 'Engagement',
    images: [involvementFair1, involvementFair2]
  },
  {
    id: 'library-remodel',
    title: 'A Better Way to Book Library Rooms',
    description: 'Room reservations just got a major upgrade. New navigation paths - shaped by student input - make it easier than ever to browse, find, and reserve rooms. Students made more than 27,000 reservations in the last year.',
    icon: '📚',
    category: 'Academic',
    images: [libraryReservations1, libraryReservations2]
  },
  {
    id: 'athletics',
    title: 'Follow Every Buckeye Victory',
    description: 'All varsity sports, one powerful hub. Follow your favorite teams, track upcoming games, check recent scores, and stay current with the latest news - your complete Buckeye athletics experience.',
    icon: '🏈',
    category: 'Athletics',
    images: [athletics1, athletics2]
  },
  {
    id: 'weather',
    title: 'Weather That Works With Your Schedule',
    description: 'Never get caught in the rain again. Check current conditions at a glance or see weather forecasts embedded right in your calendar - so you\'re always prepared for whatever the day brings.',
    icon: '🌤️',
    category: 'Campus Life',
    images: [weather1, weather2]
  }
];

export const comingFeatures2026 = [
  {
    id: 'wheres-brutus',
    title: 'Where\'s Brutus Scavenger Hunt',
    description: 'The beloved Ohio Stater tradition goes digital. Hunt for Brutus across campus through the app, compete with fellow Buckeyes, and unlock badges as you explore your university.',
    icon: '🔍',
    category: 'Engagement',
    status: 'Coming 2026'
  },
  {
    id: 'housing',
    title: 'Seamless Move-In Experience',
    description: 'Your move-in day, simplified. Access everything you need - from housing assignments and move-in schedules to facility maps and essential checklists - all in one convenient place.',
    icon: '🏘️',
    category: 'Campus Life',
    status: 'Coming 2026'
  },
  {
    id: 'cota',
    title: 'Tap and Ride with COTA',
    description: 'Your phone becomes your bus pass. Scan directly from the Ohio State App to board COTA buses - no more fumbling for your BuckID. Getting around Columbus just got easier.',
    icon: '🚌',
    category: 'Transportation',
    status: 'Coming 2026'
  },
  {
    id: 'cabs-planner',
    title: 'Smart Campus Transit Planner',
    description: 'Navigate campus like a pro. Get personalized route recommendations, real-time arrival updates, and the fastest connections across the OSU transit system - your intelligent guide to getting anywhere on campus.',
    icon: '🗺️',
    category: 'Transportation',
    status: 'Coming 2026'
  }
];
